// Classes.
import Handler from './Handler';
import type event from "../Types/Event";

/**
 * Scrolly.Blocker
 *
 * @author: FelixKiesewetter <info@felixkiesewetter.de>
 * @lastModified: 2026-06-10 Created.
 * @package fk_js/scrolly
 * @version: 1.0.0
 */
class Blocker extends Handler
{

    private block :boolean = false;
    private lastScrollTop :number = window.scrollY || 0;
    private scrollbarWidth :number;

    readonly pageElement :HTMLElement|null;

    /**
     * Constructor.
     */
    constructor()
    {
        super();
        this.pageElement = document.querySelector('#page, .page, body > *:first-child'); // TODO: what if all content is directly in <body>?
        this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    }

    /**
     * Define default options.
     */
    public defaults() :object
    {
        return {};
    }

    /**
     * This handler listens to the no actual event, it manipulates CSS.
     */
    public events() :event[]
    {
        return [];
    }

    /**
     * Block scrolling.
     */
    on() :void
    {
        if (this.block) {
            return;
        }
        this.block = true;
        this.lastScrollTop = window.scrollY;
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.height = '100%';
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
        this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${this.scrollbarWidth}px`;
        if (this.pageElement) this.pageElement.style.marginTop = `-${this.lastScrollTop}px`;
    }

    /**
     * Re-enable scrolling.
     */
    off() :void
    {
        if (!this.block) {
            return;
        }
        this.block = false;
        document.documentElement.style.overflow = '';
        document.documentElement.style.height = '';
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.paddingRight = '';
        if (this.pageElement) this.pageElement.style.marginTop = '';
        window.scrollTo({
            top: this.lastScrollTop,
            behavior: 'instant'
        });
    }

}

export default Blocker;